const GET_CONTACT_VALIDATION = 'core/contactValidation/GET_CONTACT_VALIDATION';
const GET_CONTACT_VALIDATION_COMPLETED = 'core/contactValidation/GET_CONTACT_VALIDATION_COMPLETED';
const GET_CONTACT_VALIDATION_FAILED = 'core/contactValidation/GET_CONTACT_VALIDATION_FAILED';
const UPDATE_CONTACT_VALIDATION = 'core/contactValidation/UPDATE_CONTACT_VALIDATION';
const UPDATE_CONTACT_VALIDATION_COMPLETED = 'core/contactValidation/UPDATE_CONTACT_VALIDATION_COMPLETED';
const UPDATE_CONTACT_VALIDATION_FAILED = 'core/contactValidation/UPDATE_CONTACT_VALIDATION_FAILED';

export {
  GET_CONTACT_VALIDATION,
  GET_CONTACT_VALIDATION_COMPLETED,
  GET_CONTACT_VALIDATION_FAILED,
  UPDATE_CONTACT_VALIDATION,
  UPDATE_CONTACT_VALIDATION_COMPLETED,
  UPDATE_CONTACT_VALIDATION_FAILED
};
